import type { ReactNode } from "react";

interface LeaguePageHeaderProps {
  breadcrumb?: ReactNode;
  title: ReactNode;
  meta?: ReactNode;
  action?: ReactNode;
}

export function LeaguePageHeader({
  breadcrumb,
  title,
  meta,
  action,
}: LeaguePageHeaderProps) {
  return (
    <div className="lg:flex lg:items-center">
      <div className="min-w-0 flex-1">
        {breadcrumb}
        <h1 className="my-2 text-2xl font-semibold poppins tracking-tight text-text-primary sm:text-3xl flex items-center min-w-0">
          {title}
        </h1>
        {meta && (
          <div className="mt-1 flex flex-col sm:mt-0 sm:flex-row sm:flex-wrap sm:space-x-6">
            {meta}
          </div>
        )}
      </div>
      {action && (
        <div className="mt-5 flex lg:mt-0 lg:ml-4">
          <span className="hidden sm:block">{action}</span>
        </div>
      )}
    </div>
  );
}
